import { Observable } from 'rxjs';
import { CancelationRepository } from '../repositories/cancelation.repository';
import {
    CancelationInterface,
    CancelationResponseInterface,
} from '../models/cancelation.model';
import { UseCase } from '@/core/base/use-case';

export class cancelReservationUseCase
    implements UseCase<CancelationInterface, CancelationResponseInterface>
{
    constructor(private readonly repository: CancelationRepository) {}

    execute(
        params: CancelationInterface,
    ): Observable<CancelationResponseInterface> {
        return this.repository.cancelReservation(params);
    }
}
